<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<script>

import BaseDataComponent from "@/core/components/BaseDataComponent.vue";

export default {
	extends: BaseDataComponent,
	name: "BaseVModelView",
	props: {
		// value: null,
		modelValue: null,
		formatDataInProp: Function,
		formatDataOutProp: Function
	},
	watch: {
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				// console.log("BaseVModelView: this.valueData = ", this.valueData, ", newVal = ", newVal, ", oldVal = ", oldVal)
				this.notifyIncomingValueChanged()
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				// console.log("BaseVModelView: this.valueData = ", this.valueData, ", newVal = ", newVal, ", oldVal = ", oldVal)
				this.notifyIncomingValueChanged()
			},
		},
	},
	data() {
		return {
			valueData: null,
		}
	},

	mounted(){
		this.onIncomingValueChanged(this.modelValue)
	},

	methods: {

		notifyIncomingValueChanged(){
			// console.log("BaseVModelView: notifyIncomingValueChanged = ", this.valueData, ", newVal = ", this.value)

			this.valueData = this.formatInInternal(this.modelValue)
			this.onValueChanged(this.modelValue)
		},

		onIncomingValueChanged(newVal){

		},

		onValueChanged(newVal){

		},

		formatDataIn(data) {
			return data
		},

		formatDataOut(data) {
			return data
		},

		notifyValueChanged() {
			console.log("notifyValueChanged: this.valueData = ", this.valueData)

			return this.notifyValueChangedInternal()
		},

		notifyValueChangedInternal() {
			let data = this.formatOutInternal(this.valueData)
			console.log("notifyValueChangedInternal: data = ", data)

			this.$emit('update:modelValue', data)
			this.$emit('input', data)
			this.$emit('change', data)

			return data
		},

		formatInInternal(value) {
			if(this.formatDataInProp){
				return this.formatDataInProp(value)
			}
			return this.formatDataIn(value)
		},

		formatOutInternal(value) {
			if(this.formatDataOutProp){
				return this.formatDataOutProp(value)
			}
			return this.formatDataOut(value)
		},
	},

	computed: {


		loadDataOnStartComputed(){
			return false
		},

		value: {
			get: function (){
				return this.modelValue
			},
		},

		// valueData:{
		// 	get: function (){
		// 		return this.formatInInternal(this.value)
		// 	},
		//
		// 	set: function (val){
		// 		this.notifyValueChanged(val)
		// 	}
		// }

	}

}
</script>

<style>

</style>
